"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _PanelComponentRegistrationContext = require("../context/PanelComponentRegistrationContext");

var _default = _react.default.createClass({
  displayName: "UIPanelBody",
  propTypes: {
    children: _react.PropTypes.node
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className"]);
    return _react.default.createElement("div", (0, _extends2.default)({}, rest, {
      className: (0, _classNames.default)(className, 'private-panel__body')
    }), _react.default.createElement(_PanelComponentRegistrationContext.RegistersPanelBody, null), children);
  }
});

exports.default = _default;
module.exports = exports.default;